import type { SelectOption } from '../../../types';

export enum Tab {
  Project = 'In This Project',
  Global = 'Global',
  Revision = 'In This Revision',
}

export type LabelOption = SelectOption<number>;

export type VersionedLabelOption = Record<string, Set<number>>;
